/** ISO date (YYYY-MM-DD) from event.start_date for range checks. */
export function eventStartDateKey(event: { start_date?: string }): string | null {
  if (!event?.start_date) {
    return null;
  }
  return String(event.start_date).slice(0, 10);
}

/** API endDate is exclusive (startDate <= event day < endDate). */
export function isEventStartInDateRange(
  event: { start_date?: string },
  startDate: string,
  endDate: string
): boolean {
  const d = eventStartDateKey(event);
  if (!d) {
    return false;
  }
  return d >= startDate && d < endDate;
}

/**
 * Merge a fetch into the calendar event list: upsert by guid, and for the
 * requested window remove stale entries that are no longer returned.
 */
export function mergeCalendarEventLists(
  existing: any[],
  incoming: any[],
  queryParams: { startDate?: string; endDate?: string } | null | undefined,
  replaceCache: boolean
): any[] {
  if (replaceCache) {
    return [...incoming];
  }
  if (!queryParams?.startDate || !queryParams?.endDate) {
    return incoming.length ? [...incoming] : [...existing];
  }

  const map = new Map<string, any>();
  for (const e of existing) {
    if (e?.guid) {
      map.set(String(e.guid), e);
    }
  }

  for (const [guid, e] of [...map.entries()]) {
    if (isEventStartInDateRange(e, queryParams.startDate, queryParams.endDate)) {
      map.delete(guid);
    }
  }

  for (const e of incoming) {
    if (e?.guid) {
      map.set(String(e.guid), e);
    }
  }

  return Array.from(map.values());
}
